import gql from 'graphql-tag';
export const adAllocationFragment = gql `
  fragment AdAllocation on EntityAdAllocation {
    id
    adSets {
      adSetAllocations {
        id
        percentage
        events
        entityAdAllocationId
      }
      id
      name
      adFiles {
        file {
          url
          id
        }
        size
        adSetId
      }
      teamId
    }
    config {
      events
      teams {
        home {
          percentage
          enabled
        }
        away {
          percentage
          enabled
        }
      }
      loop {
        enabled
        type
        secsBetweenShows
        secsPerShow
        perPeriod
      }
    }
  }
`;
//# sourceMappingURL=AdAllocation.js.map